import { createReverseObjectMap, type ReverseObjectMap } from "@mcwd/typescript-type-guards";

export const OneTrustCategoryId = ["C0001", "C0002", "C0003", "C0004", "C0005", "SSPD_BG"] as const;
export type OneTrustCategoryId = (typeof OneTrustCategoryId)[number];


export const OneTrustCategoryIdToNameMapping = {
  "C0001": "Strictly Necessary",
  "C0002": "Performance",
  "C0003": "Functional",
  "C0004": "Targeting",
  "C0005": "Social Media",
  "SSPD_BG": "Share or Sale of Personal Data"
} as const satisfies Record<OneTrustCategoryId, string>;

export type OneTrustCategoryIdToNameMapping = typeof OneTrustCategoryIdToNameMapping;
export type OneTrustCategoryNameToIdMapping = ReverseObjectMap<OneTrustCategoryIdToNameMapping>;
export const OneTrustCategoryNameToIdMapping = createReverseObjectMap(OneTrustCategoryIdToNameMapping) satisfies OneTrustCategoryNameToIdMapping;

export type OneTrustCategoryName = OneTrustCategoryIdToNameMapping[ OneTrustCategoryId ];
export const OneTrustCategoryName = Object.values(OneTrustCategoryIdToNameMapping) as OneTrustCategoryName[];

Object.freeze(OneTrustCategoryIdToNameMapping);
Object.freeze(OneTrustCategoryNameToIdMapping);
Object.freeze(OneTrustCategoryId);
Object.freeze(OneTrustCategoryName);

export type OneTrustCategoryLabels = `${OneTrustCategoryName} Cookies`;
export const OneTrustCategoryLabels = Object.freeze(OneTrustCategoryName.map(n => `${n} Cookies`)) as OneTrustCategoryLabels[];